export default {"src":"/_next/static/media/curved-arrow.cf62ae02.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};